import { fetchDziXML } from '../api';
import { DOUBLE_BUFFERING_ENABLED, FORCE_DPR_VALUE, IS_DEV_MODE_ENABLED, IS_FORCE_DPR, USE_DPR_DEFAULT_VALUE, } from '../consts';
import { Controls } from './Controls';
import { Images } from './Images';
import { MetaData } from './Metadata';
import { Renderer } from './Renderer';
import { ViewerDebugger } from './ViewerDebugger';
import { Viewport } from './Viewport';
import { parseDziXML } from '../utils/helpers';
export class Viewer {
    constructor(tilesUrl, dziUrl, placeholderElement, drawShadows, drawSpotlight, isDarkMode, useDpr) {
        Object.defineProperty(this, "TILES_URL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "DZI_URL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "placeholderURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "placeholderElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "VIEWER_DOM_EL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isViewerResized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "drawShadows", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "drawSpotlight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDarkMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "useDpr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoomInAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "zoomOutAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "setZoomToInitial", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "setZoomToMax", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "movePositionAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "setZoomLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "setZoomLevelAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "getViewport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "zoomIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "zoomOut", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "getZoomPercentage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "onInitCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return null;
            }
        });
        Object.defineProperty(this, "viewport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "onViewportChangeCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "setOnViewportChangeCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onViewportChangeCallback = callback;
            }
        });
        Object.defineProperty(this, "getViewer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.VIEWER_DOM_EL;
            }
        });
        Object.defineProperty(this, "initApp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                fetchDziXML(this.DZI_URL).then((xmlText) => {
                    const parsedDzi = parseDziXML(xmlText);
                    const fetchedLayers = parsedDzi.levelsData;
                    const originalSize = {
                        width: parsedDzi.originalWidth ?? 0,
                        height: parsedDzi.originalHeight ?? 0,
                    };
                    const spotlightCanvasEl = document.createElement('canvas');
                    const shadowsCanvasEl = document.createElement('canvas');
                    const canvasEl = document.createElement('canvas');
                    const visibleCanvasEl = document.createElement('canvas');
                    shadowsCanvasEl.style.position = 'absolute';
                    shadowsCanvasEl.style.top = '0';
                    shadowsCanvasEl.style.left = '0';
                    shadowsCanvasEl.style.pointerEvents = 'none';
                    shadowsCanvasEl.style.zIndex = '-1';
                    spotlightCanvasEl.style.position = 'absolute';
                    spotlightCanvasEl.style.top = '0';
                    spotlightCanvasEl.style.left = '0';
                    spotlightCanvasEl.style.pointerEvents = 'none';
                    spotlightCanvasEl.style.zIndex = '-1';
                    spotlightCanvasEl.style.filter = 'blur(80px)';
                    visibleCanvasEl.style.cursor = 'pointer';
                    const controlsArea = document.createElement('div');
                    controlsArea.style.position = 'absolute';
                    this.VIEWER_DOM_EL.appendChild(controlsArea);
                    this.VIEWER_DOM_EL.appendChild(DOUBLE_BUFFERING_ENABLED ? visibleCanvasEl : canvasEl);
                    this.VIEWER_DOM_EL.appendChild(spotlightCanvasEl);
                    this.VIEWER_DOM_EL.appendChild(shadowsCanvasEl);
                    this.initViewer(this.VIEWER_DOM_EL, canvasEl, visibleCanvasEl, shadowsCanvasEl, spotlightCanvasEl, controlsArea, fetchedLayers, originalSize, this.placeholderURL);
                });
            }
        });
        Object.defineProperty(this, "initViewer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (wrapperEl, canvasEl, visibleCanvasEl, shadowsCanvasEl, spotlightCanvasEl, controlsArea, fetchedLayers, originalSize, placeholderURL) => {
                const ctx = canvasEl.getContext('2d');
                const visibleCtx = visibleCanvasEl.getContext('2d');
                const shadowsCtx = shadowsCanvasEl.getContext('2d');
                const spotlightCtx = spotlightCanvasEl.getContext('2d');
                if (!ctx || !visibleCtx || !shadowsCtx || !spotlightCtx)
                    return;
                const initialViewportSize = {
                    x: 0,
                    y: 0,
                    w: wrapperEl.clientWidth,
                    h: wrapperEl.clientHeight,
                };
                const setCanvasSizeFullSize = () => {
                    canvasEl.width =
                        wrapperEl.clientWidth * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    canvasEl.height =
                        wrapperEl.clientHeight * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    canvasEl.style.width = '100%';
                    canvasEl.style.height = '100%';
                    shadowsCanvasEl.width =
                        wrapperEl.clientWidth * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    shadowsCanvasEl.height =
                        wrapperEl.clientHeight * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    shadowsCanvasEl.style.width = '100%';
                    shadowsCanvasEl.style.height = '100%';
                    spotlightCanvasEl.width =
                        wrapperEl.clientWidth * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    spotlightCanvasEl.height =
                        wrapperEl.clientHeight * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    spotlightCanvasEl.style.width = '100%';
                    spotlightCanvasEl.style.height = '100%';
                    visibleCanvasEl.width =
                        wrapperEl.clientWidth * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    visibleCanvasEl.height =
                        wrapperEl.clientHeight * (IS_FORCE_DPR ? FORCE_DPR_VALUE : this.useDpr ? (window?.devicePixelRatio ?? 1) : 1);
                    visibleCanvasEl.style.width = '100%';
                    visibleCanvasEl.style.height = '100%';
                };
                const onResizeActions = () => {
                    setCanvasSizeFullSize();
                    viewport.setViewportSize({
                        x: 0,
                        y: 0,
                        w: wrapperEl.clientWidth,
                        h: wrapperEl.clientHeight,
                    });
                    viewport.setCalculatedMinPercentageVal();
                    renderer.render();
                };
                setCanvasSizeFullSize();
                const initialLevel = 0;
                const metadata = new MetaData(fetchedLayers, originalSize);
                const viewport = new Viewport(metadata.getLayers(), initialLevel, metadata.getZoomLevels(), initialViewportSize, this.useDpr);
                const images = new Images(this.TILES_URL, metadata.getLayers(), viewport);
                const renderer = new Renderer(ctx, visibleCtx, canvasEl, shadowsCtx, spotlightCtx, viewport, images, placeholderURL, this.drawShadows, this.drawSpotlight, this.isDarkMode);
                const controls = new Controls(canvasEl, controlsArea, viewport);
                this.viewport = viewport;
                const viewerDebugger = IS_DEV_MODE_ENABLED ? new ViewerDebugger(viewport, this.VIEWER_DOM_EL) : null;
                images.setOnAnyImageLoadedCallback(renderer.render);
                images.loadAndAddImageIfNotExist(initialLevel, 0, 0, true);
                viewport.setFullImageProps(metadata.getFullImageProps(viewport.getLevel()));
                viewport.setOnVisibleTilesChangeCallback((level, tilesList) => {
                    images.loadImagesByTilesNames(level, tilesList.firstX, tilesList.firstY, tilesList.lastX, tilesList.lastY);
                });
                viewport.setClearImagesLevelCache((level) => {
                    images.clearLevel(level);
                });
                viewport.setMoveCallback(() => {
                    renderer.render();
                    if (this.onViewportChangeCallback)
                        this.onViewportChangeCallback(viewport);
                    if (viewerDebugger)
                        viewerDebugger.renderDebugInfo();
                });
                viewport.setOnLevelChangeCallback(() => {
                    if (this.onViewportChangeCallback)
                        this.onViewportChangeCallback(viewport);
                });
                controls.setMoveCallback((x, y) => {
                    viewport.movePosition(x, y);
                });
                controls.setTouchMoveCallback((x, y) => {
                    viewport.moveArtworkToCertainPoint(x, y);
                });
                controls.setMoveAnimatedCallback((x, y) => {
                    viewport.movePositionAnimated(x, y);
                });
                controls.setMoveUnpressedCallback((x, y) => {
                    viewport.setPointerPosition(x, y);
                });
                controls.setInertnessMoveCallback((x, y) => {
                    viewport.movePositionAnimated(x, y);
                });
                controls.setDblclickCallback(() => {
                    viewport.increaseZoomAnimated(undefined, true, 200);
                });
                controls.setCenterImageCallback(() => {
                    viewport.centerImage();
                    renderer.render();
                });
                controls.setScaleImageIncreaseAnimatedCallback((step, setPosByPointer = false) => {
                    viewport.increaseZoomAnimated(step, setPosByPointer);
                    renderer.render();
                });
                controls.setScaleImageDecreaseAnimatedCallback((step, setPosByPointer = false) => {
                    viewport.decreaseZoomAnimated(step, setPosByPointer);
                    renderer.render();
                });
                controls.setScaleImageSetValueCallback((percentage) => {
                    viewport.setZoomLevel(percentage);
                    renderer.render();
                });
                controls.setZoomLevelAnimatedCallback((val, setPosByPointer) => {
                    requestAnimationFrame(() => {
                        viewport.setZoomLevelAnimated(val, setPosByPointer, undefined, 50);
                    });
                });
                controls.bindMoveEventsHandlers(DOUBLE_BUFFERING_ENABLED ? visibleCanvasEl : canvasEl);
                controls.setOnInitialPointerPosSetCallback((x, y) => {
                    viewport.setPointerPosition(x, y);
                });
                onResizeActions();
                renderer.render();
                addEventListener('resize', () => {
                    this.isViewerResized = true;
                    onResizeActions();
                });
                this.zoomInAnimated = viewport.increaseZoomAnimated;
                this.zoomOutAnimated = viewport.decreaseZoomAnimated;
                this.setZoomLevelAnimated = viewport.setZoomLevelAnimated;
                this.setZoomLevel = (zoomLevel, setPointerPosition = false) => {
                    viewport.setZoomLevel(zoomLevel, setPointerPosition);
                    renderer.render();
                };
                this.zoomIn = () => {
                    viewport.increaseZoom();
                    renderer.render();
                };
                this.zoomOut = () => {
                    viewport.decreaseZoom();
                    renderer.render();
                };
                this.getZoomPercentage = () => {
                    return viewport.getZoomPercentage();
                };
                this.getViewport = () => {
                    return viewport;
                };
                this.movePositionAnimated = viewport.movePositionAnimated;
                this.setZoomToInitial = () => {
                    viewport.setZoomLevelToInitial(700);
                    renderer.render();
                };
                this.setZoomToMax = () => {
                    viewport.setZoomLevelToMax(700);
                    renderer.render();
                };
                if (this.placeholderElement) {
                    viewport.setInitialPositionToFitDOMElement(this.placeholderElement);
                }
                this.onInitCallback(viewport, this.TILES_URL);
                if (this.onViewportChangeCallback)
                    this.onViewportChangeCallback(viewport);
            }
        });
        Object.defineProperty(this, "setOnInitCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callback) => {
                this.onInitCallback = callback;
            }
        });
        Object.defineProperty(this, "setInitialPositionToFitDomElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.placeholderElement && this.viewport?.setInitialPositionToFitDOMElement) {
                    this.viewport.setInitialPositionToFitDOMElement(this.placeholderElement);
                }
            }
        });
        Object.defineProperty(this, "animateOnOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                await new Promise((resolve, reject) => {
                    if (this.viewport?.animateTransitionToViewerPosition) {
                        this.viewport.animateTransitionToViewerPosition(350).then(() => {
                            resolve();
                        });
                    }
                    else {
                        reject('animateTransitionToViewerPosition is not defined');
                    }
                });
            }
        });
        Object.defineProperty(this, "animateOnClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                return new Promise(async (resolve) => {
                    if (!this.isViewerResized) {
                        await this.viewport?.animateTransitionToPreviewPosition(350);
                        resolve();
                    }
                    else {
                        resolve();
                    }
                });
            }
        });
        this.TILES_URL = tilesUrl;
        this.DZI_URL = dziUrl;
        this.placeholderURL = placeholderElement?.currentSrc;
        this.placeholderElement = placeholderElement;
        this.drawShadows = drawShadows || false;
        this.drawSpotlight = drawSpotlight || false;
        this.isDarkMode = isDarkMode || false;
        this.useDpr = useDpr === undefined ? USE_DPR_DEFAULT_VALUE : useDpr;
        if (this.TILES_URL && this.DZI_URL) {
            this.initApp();
        }
        else {
            throw new Error('not enough data to init viewer');
        }
        const viewerWrapperElement = document.createElement('div');
        viewerWrapperElement.style.width = '100%';
        viewerWrapperElement.style.height = '100%';
        this.VIEWER_DOM_EL = viewerWrapperElement;
    }
}
